/* Keep the Shopify Inbox launcher off every buy control on every theme, without blinking (owner, 2026-10-31: "왔다 갔다 하는 것 자체가 너무 부산스러워").
   Inbox draws it at z-index 2147483000, above every theme layer. Its wrapper (.activator-nudge) takes taps too, so the
   wrapper is what hides: hiding only the ::part(activator) button leaves an invisible tap-eater behind.
   Once a sticky buy bar has shown on a page the launcher stays hidden until the next page. Otherwise it changes only
   when the page is at rest: hidden while it sits on a button, field or swatch, on a link in the buy column or in a
   fixed layer (popup, drawer, banner), and right away while a drawer or modal locks the page. */
(() => {
  const BARS = '.satc-ak, .satc-tb, .sticky-add-to-cart__bar';
  const TAP = 'button, input, select, textarea, summary, label, [role="button"], a[class*="button"], a[href*="checkout"]';
  const ZONE = '.product__info-wrapper, .product-form, .product-details, form[action*="/cart"]';
  const GAP = 8;
  const SETTLE = 8; // frames without scrolling before the launcher may change
  let launcher;
  const find = (root) => {
    for (const el of root.querySelectorAll('*')) {
      if ((el.getAttribute('part') || '').split(' ').includes('activator')) return el;
      const hit = el.shadowRoot && find(el.shadowRoot);
      if (hit) return hit;
    }
  };
  const inFixed = (el) => {
    for (; el; el = el.parentElement) if (getComputedStyle(el).position === 'fixed') return true;
    return false;
  };
  const covers = (el) =>
    !el.closest('shopify-chat') && (el.closest(TAP) || (el.closest('a') && (el.closest(ZONE) || inFixed(el))));
  const blocked = (l, t, r, b) => {
    const rows = Math.ceil((b - t) / 16); // 16px apart, so a short control cannot fit between two rows
    for (let i = 0; i <= 4; i++) {
      for (let j = 0; j <= rows; j++) {
        if (document.elementsFromPoint(l + ((r - l) * i) / 4, t + ((b - t) * j) / rows).some(covers)) return true;
      }
    }
    return false;
  };

  let lastY = -1;
  let still = 0;
  let barSeen = false;
  let tuck = false;
  const tick = () => {
    requestAnimationFrame(tick);
    if (!launcher || !launcher.isConnected) {
      const host = document.querySelector('shopify-chat');
      launcher = host && host.shadowRoot && find(host.shadowRoot);
      if (!launcher) return;
      still = 0;
    }
    const box = launcher.getBoundingClientRect();
    if (!box.width) return; // the chat window is open
    const wrap = launcher.parentElement;
    barSeen ||= [...document.querySelectorAll(BARS)].some(
      (bar) => bar.getClientRects().length && bar.getBoundingClientRect().top < innerHeight // display:none bars read top 0
    );
    const locked = [document.documentElement, document.body].some((el) => getComputedStyle(el).overflowY === 'hidden');
    still = scrollY === lastY ? still + 1 : 0;
    lastY = scrollY;
    const settled = still >= SETTLE;
    wrap.style.pointerEvents = launcher.style.pointerEvents = settled ? '' : 'none'; // until it is decided, a tap belongs to the page
    if (barSeen || locked) tuck = true;
    else if (settled && !((still - SETTLE) % 6)) // decide only at rest, so the launcher never blinks during a scroll
      tuck = blocked(box.left - GAP, box.top - GAP, box.right + GAP, box.bottom + GAP);
    wrap.style.visibility = tuck ? 'hidden' : ''; // every frame: Inbox replaces the wrapper while it starts up
  };
  tick();
})();
